import React, { useState, useRef, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import s from './styles/DateRangeSelector.module.css'; // для кастомных стилей
import './styles/newCSSCalendar.css'

const DateRangeSelector = ({ value, onChange }) => {
  const [range, setRange] = useState([null, null]);
  const [showCalendar, setShowCalendar] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (value && value[0] && value[1]) {
      setRange(value);
    }
  }, [value]);

  const formatDate = (date) => {
    return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const handleCalendarChange = (selectedRange) => {
    setRange(selectedRange);
    if (onChange) {
      onChange(selectedRange);
    }
    setShowCalendar(false); // скрываем календарь после выбора
  };

  const setToday = () => {
    const today = new Date();
    setRange([today, today]);
    if (onChange) onChange([today, today]);
    setShowCalendar(false);
  };

  const setLast7Days = () => {
    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 6);
    setRange([past, today]);
    if (onChange) onChange([past, today]);
    setShowCalendar(false);
  };

  const setLast30Days = () => {
    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 29);
    setRange([past, today]);
    if (onChange) onChange([past, today]);
    setShowCalendar(false);
  };

  // Закрывать календарь при клике вне
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const prevMonth = new Date();
  prevMonth.setMonth(prevMonth.getMonth() - 1);

  return (
    <div className={s.date_range_selector} ref={containerRef}>
      <div
        className={s.inputField}
        onClick={() => setShowCalendar((prev) => !prev)}
      >
        {range[0] && range[1]
          ? `${formatDate(range[0])} — ${formatDate(range[1])}`
          : 'Выберите диапазон'}
      </div>

      {showCalendar && (
        <div className={s.calendarPopup}>
          <div className={s.buttons}>
            <button onClick={setToday}>Сегодня</button>
            <button onClick={setLast7Days}>7 дней</button>
            <button onClick={setLast30Days}>30 дней</button>
          </div>
          <Calendar
            selectRange
            onChange={handleCalendarChange}
            value={range}
            locale="ru-RU"
            showDoubleView={true}
            defaultActiveStartDate={prevMonth}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangeSelector;
